import { Component, OnInit, HostBinding } from "@angular/core";

@Component({
	selector: "app-add-button",
	templateUrl: "./add-button.component.html",
	styleUrls: ["./add-button.component.scss"],
})
export class AddButtonComponent implements OnInit {
	@HostBinding("attr.accesskey") accessKey: string;

	constructor() {}

	ngOnInit(): void {
		this.accessKey = "a";
	}
}
